import { useCurrentUser } from '../hooks/useCurrentUser.js';
import { SentMessageItem } from './SentMessageItem.js';
import { ReceivedMessageItem } from './ReceivedMessageItem.js';
import { DirectMessageState } from '../state/messagesSlice.js';

type MessageItemProps = {
	item: DirectMessageState;
	readOnly?: boolean;
	index?: number;
};

function LoadingMessage() {
	return <div style={{ height: 20 }} />;
}

export const MessageItem: React.FC<MessageItemProps> = props => {
	const currentUser = useCurrentUser();
	if (!currentUser._id) {
		return <LoadingMessage />;
	}
	return props.item.from === currentUser._id ? <SentMessageItem {...props} /> : <ReceivedMessageItem {...props} />;
};
